import {
  APP_ERROR_TYPE,
  ERROR_USER_INTERFACE,
  ErrorsByStatusesWithDefault,
} from './types';

// Error configurations shared between query and mutation handlers
export const COMMON_400_ERRORS: ErrorsByStatusesWithDefault = [
  {
    type: APP_ERROR_TYPE.BAD_REQUEST,
    userInterface: ERROR_USER_INTERFACE.DIALOG,
    isDefault: true,
  },
  {
    type: APP_ERROR_TYPE.ACTION_CANNOT_BE_APPROVED,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ACTION_CANNOT_BE_DECLINED,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ACTION_CANNOT_BE_FINISHED,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ACTION_CANNOT_BE_STARTED,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ISSUE_SUBTYPE_HAS_LINKED_ISSUE_MANAGERS_ERROR,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ISSUE_SUBTYPE_HAS_ISSUE_MANAGER_OF_ISSUE_TYPE,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ISSUE_TYPE_HAS_ISSUE_MANAGER_OF_ISSUE_SUBTYPES,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ISSUE_SUBTYPE_ALREADY_EXISTS_ERROR,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ISSUE_TEMPLATE_ALREADY_EXISTS,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.SLA_ALREADY_EXISTS_ERROR,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ISSUE_TEMPLATE_DUE_DATE_IS_GREATER_THAN_SLA,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ACTION_DUE_DATE_MUST_BE_LESS_OR_EQUAL_THAN_ISSUE_TEMPLATE_DUE_DATE,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.INVALID_ISSUE_TYPE_SUBTYPE,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
];

export const COMMON_401_ERRORS: ErrorsByStatusesWithDefault = [
  {
    type: APP_ERROR_TYPE.UNAUTHORIZED,
    userInterface: ERROR_USER_INTERFACE.DIALOG,
    isDefault: true,
  },
  {
    type: APP_ERROR_TYPE.USER_CANNOT_UPDATE_ACTION,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
];

export const COMMON_409_ERRORS: ErrorsByStatusesWithDefault = [
  {
    type: APP_ERROR_TYPE.BAD_REQUEST,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: true,
  },
  {
    type: APP_ERROR_TYPE.ISSUE_ALREADY_CLOSED_ERROR,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ISSUE_SLA_ALREADY_DISABLED_ERROR,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ISSUE_SLA_ALREADY_ENABLED_ERROR,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
  {
    type: APP_ERROR_TYPE.ISSUE_TEMPLATE_ALREADY_EXISTS,
    userInterface: ERROR_USER_INTERFACE.TOAST,
    isDefault: false,
  },
];

export const queryErrorsByStatuses: Record<
  number,
  ErrorsByStatusesWithDefault
> = {
  400: COMMON_400_ERRORS,
  401: COMMON_401_ERRORS,
  403: [
    {
      type: APP_ERROR_TYPE.FORBIDDEN,
      userInterface: ERROR_USER_INTERFACE.DIALOG,
      isDefault: true,
    },
    {
      type: APP_ERROR_TYPE.UNAUTHORIZED_TO_VIEW_ISSUE,
      userInterface: ERROR_USER_INTERFACE.PAGE,
      isDefault: false,
    },
  ],
  409: COMMON_409_ERRORS,
  500: [
    {
      type: APP_ERROR_TYPE.NETWORK,
      userInterface: ERROR_USER_INTERFACE.PAGE,
      isDefault: true,
    },
  ],
  503: [
    {
      type: APP_ERROR_TYPE.MAINTENANCE_MODE_ERROR,
      userInterface: ERROR_USER_INTERFACE.PAGE,
      isDefault: true,
    },
  ],
};

export const mutationErrorsByStatuses: Record<
  number,
  ErrorsByStatusesWithDefault
> = {
  400: COMMON_400_ERRORS,
  401: COMMON_401_ERRORS,
  403: [
    {
      type: APP_ERROR_TYPE.FORBIDDEN,
      userInterface: ERROR_USER_INTERFACE.DIALOG,
      isDefault: true,
    },
  ],
  409: COMMON_409_ERRORS,
  500: [
    {
      type: APP_ERROR_TYPE.MUTATION_ERROR,
      userInterface: ERROR_USER_INTERFACE.TOAST,
      isDefault: true,
    },
  ],
  503: [
    {
      type: APP_ERROR_TYPE.MAINTENANCE_MODE_ERROR,
      userInterface: ERROR_USER_INTERFACE.PAGE,
      isDefault: true,
    },
  ],
};
